// extracted by mini-css-extract-plugin
export default {"root":"AssessmentAsset_root__bSJJf"};